// extracted by mini-css-extract-plugin
module.exports = {"ProfilePic":"About_ProfilePic__2kgDk","AboutP":"About_AboutP__39aJW","TwitterButton":"About_TwitterButton__KDfus"};